import React from "react";
import {
  ActionsCellWrapper,
  AmountCellWrapper,
  BilledCellWrapper,
  BudgetCodeCellWrapper,
  ChangeEventCellWrapper,
  DescriptionCellWrapper,
  QtyCellWrapper,
  RemainingCellWrapper,
  UnitCostCellWrapper,
  UomCellWrapper,
} from "./SharedLineItemCells";

/**
 * Shared function to create base columns (common to both PurchaseOrder and Subcontract tables)
 */
export const createBaseColumns = (handleEdit, handleRemoveRow, dropdownOptions, getDisplayText) => [
  {
    accessorKey: "rowNumber",
    header: "#",
    size: 50,
    enableGrouping: false,
  },
  {
    accessorKey: "changeEvent",
    header: "Change Event Line Item",
    size: 220,
    Cell: ({ row }) => (
      <ChangeEventCellWrapper
        row={row}
        handleEdit={handleEdit}
        dropdownOptions={dropdownOptions}
        getDisplayText={getDisplayText}
      />
    ),
  },
  {
    accessorKey: "budgetCodeId",
    header: "Budget Code",
    size: 220,
    Cell: ({ row }) => (
      <BudgetCodeCellWrapper
        row={row}
        handleEdit={handleEdit}
        dropdownOptions={dropdownOptions}
        getDisplayText={getDisplayText}
      />
    ),
  },
  {
    accessorKey: "description",
    header: "Description",
    size: 250,
    Cell: ({ row }) => <DescriptionCellWrapper row={row} handleEdit={handleEdit} />,
  },
  {
    accessorKey: "amount",
    header: "Amount",
    size: 140,
    Cell: ({ row }) => <AmountCellWrapper row={row} handleEdit={handleEdit} />,
    muiTableBodyCellProps: { align: "right" },
    muiTableHeadCellProps: { align: "right" },
  },
  {
    accessorKey: "billed",
    header: "Billed to Date",
    size: 140,
    Cell: ({ row }) => <BilledCellWrapper row={row} handleEdit={handleEdit} />,
    muiTableBodyCellProps: { align: "right" },
    muiTableHeadCellProps: { align: "right" },
  },
  {
    accessorKey: "remaining",
    header: "Amount Remaining",
    size: 140,
    Cell: ({ row }) => <RemainingCellWrapper row={row} handleEdit={handleEdit} />,
    muiTableBodyCellProps: { align: "right" },
    muiTableHeadCellProps: { align: "right" },
  },
  {
    accessorKey: "actions",
    header: "",
    size: 60,
    enableGrouping: false,
    Cell: ({ row }) => <ActionsCellWrapper row={row} handleRemoveRow={handleRemoveRow} />,
  },
];

/**
 * Additional columns for Purchase Order table (qty, uom, unitCost)
 */
export const createPurchaseOrderAdditionalColumns = (
  handleEdit,
  dropdownOptions,
  getDisplayText
) => [
  {
    accessorKey: "qty",
    header: "Qty",
    size: 120,
    Cell: ({ row }) => <QtyCellWrapper row={row} handleEdit={handleEdit} />,
    muiTableBodyCellProps: { align: "right" },
    muiTableHeadCellProps: { align: "right" },
  },
  {
    accessorKey: "uom",
    header: "UOM",
    size: 120,
    Cell: ({ row }) => (
      <UomCellWrapper
        row={row}
        handleEdit={handleEdit}
        dropdownOptions={dropdownOptions}
        getDisplayText={getDisplayText}
      />
    ),
  },
  {
    accessorKey: "unitCost",
    header: "Unit Cost",
    size: 140,
    Cell: ({ row }) => <UnitCostCellWrapper row={row} handleEdit={handleEdit} />,
    muiTableBodyCellProps: { align: "right" },
    muiTableHeadCellProps: { align: "right" },
  },
];
